module.exports = __webpack_public_path__ + "static/media/dermaroller.e387c7a4.png";